import { Language } from '@libs/index';
import { LOCALIZATION_LOCALE } from '@libs/index';
import { COUNTRY_CODE } from '@libs/index';
import { GOOGLE_LANGUAGE_CODE } from '@libs/index';

// The first element in array will be default language
export const SUPPORTED_LANGUAGE: Language[] = [
  {
    languageCode: LOCALIZATION_LOCALE.US,
    countryCode: COUNTRY_CODE.US,
    googleLanguageCode: GOOGLE_LANGUAGE_CODE.EN,
  },
  {
    languageCode: LOCALIZATION_LOCALE.DE,
    countryCode: COUNTRY_CODE.DE,
    googleLanguageCode: GOOGLE_LANGUAGE_CODE.DE,
  },
  {
    languageCode: LOCALIZATION_LOCALE.CZ,
    countryCode: COUNTRY_CODE.CZ,
    googleLanguageCode: GOOGLE_LANGUAGE_CODE.CZ,
  },
  {
    languageCode: LOCALIZATION_LOCALE.FR,
    countryCode: COUNTRY_CODE.FR,
    googleLanguageCode: GOOGLE_LANGUAGE_CODE.FR,
  },
  {
    languageCode: LOCALIZATION_LOCALE.VN,
    countryCode: COUNTRY_CODE.VN,
    googleLanguageCode: GOOGLE_LANGUAGE_CODE.VN,
  },
];
